function warn(conditionOrMessage, message) {
    if (process.env.NODE_ENV === 'development')
        if (arguments.length === 1)
            console.error('[vue-haptic]', conditionOrMessage);
        else if (conditionOrMessage)
            console.error('[vue-haptic]', message);
}

function getPattern({ value, arg }, globalOptions) {
    let pattern;
    switch (typeof value) {
        case 'number':
        case 'string':
            pattern = value;
            break;
        case 'object':
            if (value instanceof Array) {
                pattern = value;
                break;
            }
            if (value.pattern) {
                pattern = value.pattern;
                break;
            }
        default:
            pattern = arg !== null && arg !== void 0 ? arg : 'default';
            break;
    }
    const hapticPattern = typeof pattern === 'string' ? globalOptions.patterns[pattern] : pattern;
    warn(!hapticPattern, `Pattern "${pattern}" does not exist.`);
    return hapticPattern;
}

function getTrigger({ value, modifiers }, globalOptions) {
    var _a, _b;
    if (typeof value === 'function')
        return value;
    if (typeof value === 'object' && value.trigger)
        return value.trigger;
    return (_b = (_a = Object.keys(modifiers)[0]) !== null && _a !== void 0 ? _a : globalOptions === null || globalOptions === void 0 ? void 0 : globalOptions.defaultHapticTrigger) !== null && _b !== void 0 ? _b : 'pointerdown';
}

if (!('vibrate' in window.navigator))
    window.navigator.vibrate = () => { };

const patternMap = new WeakMap();
var index = {
    install(Vue, globalOptions) {
        warn(typeof globalOptions === 'undefined' ||
            typeof globalOptions.patterns !== 'object' ||
            (typeof globalOptions.patterns === 'object' && Object.keys(globalOptions.patterns).length === 0), `You must provide at least one pattern. See: https://github.com/justintaddei/vue-haptic#pattern-presets for more info.`);
        Vue.prototype.$haptics = {
            patterns: globalOptions.patterns,
            get disabled() {
                return Boolean(globalOptions === null || globalOptions === void 0 ? void 0 : globalOptions.disabled);
            },
            set disabled(disabled) {
                globalOptions.disabled = disabled;
            },
            cancel() {
                navigator.vibrate(0);
            }
        };
        Vue.directive('haptic', {
            bind(el, binding, vNode) {
                var _a, _b, _c;
                el.dataset.cancellationPeriod = (_c = (_b = (_a = binding.value) === null || _a === void 0 ? void 0 : _a.cancellationPeriod) !== null && _b !== void 0 ? _b : globalOptions.cancellationPeriod) !== null && _c !== void 0 ? _c : 75;
                const trigger = getTrigger(binding, globalOptions);
                if (!patternMap.has(el))
                    patternMap.set(el, new Map());
                patternMap.get(el).set(trigger, getPattern(binding, globalOptions));
                const vibrate = (pattern) => {
                    if (globalOptions.disabled)
                        return;
                    return navigator.vibrate(pattern !== null && pattern !== void 0 ? pattern : patternMap.get(el).get(trigger));
                };
                if (typeof trigger === 'string') {
                    if (vNode.componentInstance)
                        vNode.componentInstance.$on(trigger, () => vibrate());
                    el.addEventListener(trigger, () => {
                        var _a;
                        if (!/pointerdown|touchstart/.test(trigger) || parseInt(el.dataset.cancellationPeriod, 10) === 0)
                            vibrate();
                        else {
                            const token = setTimeout(() => {
                                vibrate();
                                document.removeEventListener('pointercancel', cancelHaptic);
                                document.removeEventListener('touchcancel', cancelHaptic);
                            }, (_a = parseInt(el.dataset.cancellationPeriod, 10)) !== null && _a !== void 0 ? _a : 75);
                            const cancelHaptic = () => {
                                clearTimeout(token);
                                document.removeEventListener('pointercancel', cancelHaptic);
                                document.removeEventListener('touchcancel', cancelHaptic);
                            };
                            document.addEventListener('pointercancel', cancelHaptic);
                            document.addEventListener('touchcancel', cancelHaptic);
                        }
                    });
                }
                else {
                    trigger((pattern) => {
                        if (globalOptions.disabled)
                            return;
                        if (!pattern)
                            return vibrate();
                        if (typeof pattern === 'string') {
                            warn(!globalOptions.patterns[pattern], `Pattern "${pattern}" does not exist.`);
                            return vibrate(globalOptions.patterns[pattern]);
                        }
                        if (typeof pattern === 'number' || pattern instanceof Array)
                            vibrate(pattern);
                        warn(`The pattern must be undefined or of type number, number[], or string. Received ${typeof pattern}`);
                    }, el);
                }
            },
            update(el, binding) {
                var _a, _b, _c;
                el.dataset.cancellationPeriod = (_c = (_b = (_a = binding.value) === null || _a === void 0 ? void 0 : _a.cancellationPeriod) !== null && _b !== void 0 ? _b : globalOptions.cancellationPeriod) !== null && _c !== void 0 ? _c : 75;
                const trigger = getTrigger(binding, globalOptions);
                warn(!patternMap.get(el).has(trigger), 'The haptic trigger cannot be updated dynamically.');
                const pattern = getPattern(binding, globalOptions);
                patternMap.get(el).set(trigger, pattern);
            }
        });
    }
};

export default index;
